var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9,
    fill: "black",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "#FED241"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4571 10.4362C13.7946 10.2433 13.7946 9.75669 13.4571 9.56384L7.93908 6.41068C7.60419 6.21931 7.1875 6.46113 7.1875 6.84684V13.1532C7.1875 13.5389 7.60419 13.7807 7.93908 13.5893L13.4571 10.4362Z",
    fill: "#FED241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay3);
export default __webpack_public_path__ + "static/media/play-3.e7cba38c0bf79c15445009797387cf2d.svg";
export { ForwardRef as ReactComponent };